<template>
  <section>
	  <div class="user-main" v-if="orderType=='cgorder'">
	    <div class="layui-card user-cont">
	      <div class="layui-card-header layui-card-header-auto">
	        <h3>订单详情</h3>
	      </div>
	      <div class="layui-card-body">
	        <div>
	          <strong>收货人：</strong>
	        </div>
	        <div class="mt10">
	          姓名：{{orderDetail.username}}
	          <br />
	          电话：{{orderDetail.telephone}}
	          <br />
	          地址：{{orderDetail.region}}{{orderDetail.address}}
	        </div>
	        <div class="mt20 flex ju-be">
	          <div ><strong>订单产品：</strong></div>
			  <div v-if="isedit">
					<el-button type="primary" size="small" @click="tianjia">添加商品</el-button>					
				</div>
	        </div>
	        <div class="cartcontent">
	          <el-table
	            :data="[orderDetail]"
	            :span-method="arraySpanMethod2"
	            border
	            style="width: 100%; margin: 20px auto"
	          >
	            <el-table-column label="订单信息" width="120">
	              <template slot-scope="scope">
	                <div class="text_l">
	                  <div>{{ scope.row.orderno }}</div>
	                  <br />
	                  <div>{{ scope.row.addtime }}</div>
	                </div>
	              </template>
	            </el-table-column>
	            <el-table-column prop="total" label="商品金额" width="120"></el-table-column>
	            <!-- <el-table-column prop="shipfee" label="运费" width="60"></el-table-column> -->
	            <!-- <el-table-column prop="discount" label="优惠" width="80"></el-table-column> -->
	            <el-table-column prop="amount" label="实付款" width="120">
	              <template slot-scope="scope">
	                <div>{{scope.row.amount}}</div>
	                <div>含运费</div>
	              </template>
	            </el-table-column>
	            <el-table-column label="商品信息"  class-name="tablegoodsinfo">
	              <template slot-scope="scope">
	                <div class="hebin" v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
	                  <div class="clearfix cpinfo flex">
	                    <div class="img">
	                      <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
	                        <img :src="item_i.indexpic" />
	                      </a>
	                    </div>
	                    
	                      <div class style="flex:1">
	                        <div class="name ellipsis-2">{{item_i.title}}</div>
	                        <div class="info">{{item_i.specnames}}</div>
	                        <div class="cart-price" v-if="!isedit">数量：{{item_i.num}}</div>
							<div class="flex ju-be" v-else>
								<div>
									<div class="numberbox">
									  <button type="button" class="btn jian"  :disabled="item_i.num<=1"  @click="xiugaiNum(item_i,'reduce',item_i.num)">
									    <span class="iconfont icon-jian"></span>
									  </button>
									  <input type="text" @change="changeNum(item_i)" :min="1" v-model="item_i.num"/>
									  <button type="button" @click="xiugaiNum(item_i,'add',item_i.num)" class="btn jia">
									    <span class="iconfont icon-jia"></span>
									  </button>
									</div>
									
								</div>
								<div v-if="isedit"><a href="javascript:;" class="color-red" @click="detelecp(item_i.id)"><i class="iconfont icon-delete"></i>删除</a></div>
							</div>
	                      </div>
	                      <div class="color-primary"   style="width:80px;text-align:center" >{{item_i.unit}}</div>
	                      <div  class="color-primary" style="width:70px;text-align:center" >{{item_i.price}}</div>
	                     
	                    
	                  </div>
	                </div>
	              </template>
	            </el-table-column>
	            <el-table-column label="单位" width="80"></el-table-column>
	            <el-table-column label="单价" width="80"></el-table-column>
	            
	            <el-table-column prop="statusText" label="订单状态" width="120"></el-table-column>
				<!-- <el-table-column prop="auditremark" label="审核备注"></el-table-column> -->
	            <!-- <el-table-column prop="amount3" width="150" label="操作">
	              <template slot-scope="scope">
	              	<div style=" text-align: center">
	              		<el-button size="small" type="success" class="mb10" v-if="levelid>1&&orderDetail.auditstatus==0"  @click="shenheOrder">审核订单</el-button>
	              		<el-button size="small" v-if="orderDetail.auditstatus==1" :disabled="orderDetail.draftid>0" :type="orderDetail.draftid>0?'default':'primary'" class="mb10" @click="submitcgOrder(orderDetail.orderno)" >{{orderDetail.draftid>0?"已生成正式单":"提交正式单"}}</el-button>
	              		<el-button size="small" v-if="orderDetail.auditstatus==2" type="primary" class="mb10 iconfont" @click="reshenghe(orderDetail.orderno)" >重新提交审核</el-button>
	              	
	              		<el-button size="small" type="danger"   @click="detelecgOrder(orderDetail.id)">删除订单</el-button>
	              	</div>
	              </template>
	            </el-table-column> -->
	          </el-table>
			<div style="text-align: center;" v-if="isedit">
				 <el-button size="small" type="primary" @click="baocun" >保存</el-button>
			 </div>
	        </div>
			
			<!-- 添加商品弹窗 -->
			<el-dialog title="添加商品" :top="'40px'" :visible.sync="showdialog">
				<div>
					<el-button type="primary" size="small" style="margin-right: 15px;" @click="tab(0)" v-if="cptype==0">签约商品</el-button>
					<el-button type="default" size="small" style="margin-right: 15px;" @click="tab(0)" v-else>签约商品</el-button>
					<el-button type="primary" size="small" @click="tab(1)"  v-if="cptype==1">全部商品</el-button>
					<el-button type="default" size="small" @click="tab(1)"  v-else>全部商品</el-button>
				</div>
				<div class="usearch mt20">
				  <input type="text" placeholder="商品名称/关键词" class="layui-input" v-model="keyword" />
				  <button type="primary" @click="searchgoods" class="layui-btn layui-btn-sm">搜索</button>
				</div>
				<el-table :data="product_list.data">
					<el-table-column prop="indexpic" width="100"  label="产品">
						<template slot-scope="scope">
							<span  target="_blank" rel="noopener noreferrer">
							  <img :src="scope.row.indexpic" alt style="width: 80px; height: 80px;" />
							</span>
						</template>
					</el-table-column>
					<el-table-column >
						<template slot-scope="scope">							
							<div class="ellipsis-2">{{scope.row.title}}</div>
							<!-- <div class="ellipsis" v-if="scope.row.showsign">
							  <span>{{scope.row.issign?'签约商品':'普通商品'}}</span>
							</div> -->
							<div style="font-size: 12px; color: #999; margin-top: 5px;" v-if="scope.row.specname">{{scope.row.specname}}</div>
							<div v-for="(item,index) in scope.row.speclist" :key="index" style="margin-top: 5px;">
								<div v-if="item.values">
									<!-- <span style="font-weight: bold;">{{item.name}}：</span>									
									<el-radio v-for="(sitem,sindex) in item.values" :key="sindex" :label="sitem.id" v-model="item.ids[index]">{{sitem.name}}</el-radio> -->
									<el-select  :placeholder="item.name" v-model="item.ids" size="mini">
									   <el-option v-for="sitem in item.values"  :key="sitem.id" :label="sitem.name" :value="sitem.id"> </el-option>
									 </el-select>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column  label="数量"  width="140">
						<template slot-scope="scope">
							
							<div class="numberbox">
							  <button type="button" class="btn jian"  :disabled="scope.row.num<=1"  @click="xiugaiNum2(scope.row,'reduce',scope.row.num)">
							    <span class="iconfont icon-jian"></span>
							  </button>
							  <input type="text"  :min="1" v-model="scope.row.num"/>
							  <button type="button" @click="xiugaiNum2(scope.row,'add',scope.row.num)" class="btn jia">
							    <span class="iconfont icon-jia"></span>
							  </button>
							</div>
						</template>
					</el-table-column>
					<el-table-column  label="单位" width="100" prop="unit"  >
						
					</el-table-column>
					<el-table-column  label="价格" width="100"  >
						<template slot-scope="scope">
							<span class="color-primary">￥{{scope.row.price}}</span>
						</template>
					</el-table-column>
					<el-table-column  label="操作" width="100" >
						<template slot-scope="scope">
							<el-button type="primary" @click="add(scope.row)">添加</el-button>
						</template>
						
					</el-table-column>
				</el-table>
				
				<el-pagination
				  class="fenye"
				  background
				  layout="prev, pager, next"
				  :page-size="~~product_list.per_page"
				  @current-change="currentPage"
				  :total="product_list.total"
				></el-pagination>
			</el-dialog>
	  
	        <div class="mt20">
	          <strong>订单信息：</strong>
	        </div>
	        <div class="mt10">
	          商品总额：￥{{orderDetail.total}}
	          <br />
	          运费：￥{{orderDetail.shipfee}}
	          <br />
	          优惠：￥{{orderDetail.discount}}
	          <br />
	          订单备注：{{orderDetail.remark||"暂无备注"}}
	          <br />
	          交易时间：{{orderDetail.addtime}}
	          <div v-if="orderDetail.refundremark2">拒绝备注:{{orderDetail.refundremark2}}</div>
	          支付方式：{{orderDetail.paymethod==1?'微信':orderDetail.paymethod==2?'支付宝':'授信'}}
	          <br />订单金额：
	          <strong class="color-red">￥{{orderDetail.amount}}</strong>
	        </div>
	      </div>
	    </div>
		<div id="adrpop" class="adrpop" style="display: none;">
		  <el-form ref="form" label-width="80px">
		    <el-form-item label="审核结果">
		        <el-radio-group v-model="audit">
		          <el-radio label="1" >同意</el-radio>
		          <el-radio label="2">拒绝</el-radio>
		        </el-radio-group>
		      </el-form-item>
			   <el-form-item label="审核备注">
			      <el-input type="textarea" v-model="remark"></el-input>
			    </el-form-item>
				<el-form-item >
				   <el-button size="small" type="primary" @click="shcgorder" class="iconfont" >提交</el-button>
				 </el-form-item>
		   </el-form>
		</div>
	  </div>
    <div class="user-main" v-if="orderType=='order'">
      <div class="layui-card user-cont">
        <div class="layui-card-header layui-card-header-auto">
          <h3>订单详情</h3>
        </div>
        <div class="layui-card-body">
          <div>
            <strong>收货人：</strong>
          </div>
          <div class="mt10">
            姓名：{{orderDetail.username}}
            <br />
            电话：{{orderDetail.telephone}}
            <br />
            地址：{{orderDetail.region}}{{orderDetail.address}}
          </div>
          <div class="mt20">
            <strong>订单产品：</strong>
          </div>
          <div class="cartcontent">
            <el-table
              :data="[orderDetail]"
              :span-method="arraySpanMethod"
              border
              style="width: 100%; margin: 20px auto"
            >
              <el-table-column label="订单信息" width="120">
                <template slot-scope="scope">
                  <div class="text_l">
                    <div>{{ scope.row.orderno }}</div>
                    <br />
                    <div>{{ scope.row.addtime }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="商品金额" width="90"></el-table-column>
              <!-- <el-table-column prop="shipfee" label="运费" width="60"></el-table-column> -->
              <!-- <el-table-column prop="discount" label="优惠" width="80"></el-table-column> -->
              <el-table-column prop="amount" label="实付款" width="120">
                <template slot-scope="scope">
                  <div>{{scope.row.amount}}</div>
                  <div>含运费</div>
                </template>
              </el-table-column>
              <el-table-column label="商品信息" width="300" class-name="tablegoodsinfo">
                <template slot-scope="scope">
                  <div class="hebin" v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
                    <div class="clearfix cpinfo flex">
                      <div class="img">
                        <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
                          <img :src="item_i.indexpic" />
                        </a>
                      </div>
                      <div class="cont flex">
                        <div class style="width:184px">
                          <div class="name ellipsis-2">{{item_i.title}}</div>
                          <div class="info">{{item_i.specnames}}</div>
                          <div class="cart-price">{{item_i.price}}*{{item_i.num}}</div>
                        </div>
                        <div
                          class="color-primary"
                          style="width:60px;text-align:center"
                        >{{item_i.unit}}</div>
                        <div
                          class="color-primary"
                          style="width:70px;text-align:center"
                        >{{item_i.price}}</div>
                        <div class="color-primary" style="width:100px;text-align:right">
                          <a
                            :href="'#/returnMoney?orderno='+scope.row.orderno+'&type=1&index='+index_i+'&numrefund='+(item_i.num-item_i.numrefund)"
                            class="color-primary"
                            v-if="item_i.numrefund==0&&item_i.isrefund!=2&&scope.row.status<=3&&scope.row.status>=1"
                          >退货/退款</a>
                          <a
                            :href="'#/returnMoney?orderno='+scope.row.orderno+'&type=1&index='+index_i+'&numrefund='+(item_i.num-item_i.numrefund)"
                            class="color-primary"
                            v-if="item_i.numrefund<item_i.num&&item_i.numrefund>0&&scope.row.status<=3&&scope.row.status>=1"
                          >退货/退款</a>
                          <a
                            :href="'#/returnMoney?detailid='+item_i.id+'&type=2'+'&numrefund='+(item_i.num-item_i.numrefund)"
                            class="color-primary"
                            v-if="item_i.numrefund==0&&item_i.isrefund==2"
                          >查看退款</a>
                          <a
                            :href="'#/returnMoney?detailid='+item_i.id+'&type=2'+'&numrefund='+(item_i.num-item_i.numrefund)"
                            class="color-primary"
                            v-if="item_i.numrefund==item_i.num"
                          >查看退款</a>
                          <a
                            :href="'#/returnMoney?detailid='+item_i.id+'&type=2'+'&numrefund='+(item_i.num-item_i.numrefund)"
                            class="color-primary"
                            v-if="item_i.numrefund<item_i.num&&item_i.numrefund>0"
                          >查看退款</a>
                          <a
                            href="javascript:;"
                            class="color-primary"
                            v-if="scope.row.status==0"
                          >暂无售后</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="单位" width="60"></el-table-column>
              <el-table-column label="单价" width="80"></el-table-column>
              <el-table-column label="售后" width="100"></el-table-column>
              <el-table-column prop="statusText" label="订单状态" width="120"></el-table-column>
              <el-table-column prop="amount3" label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    v-if="scope.row.status==2"
                    type="primary"
                    class="mb10"
                    @click="confirmGoods(scope.row.orderno)"
                  >确认收货</el-button>
                  <el-button
                    size="small"
                    v-if="scope.row.status==3 && scope.row.needComment"
                    type="primary"
                    class="mb10 pingjiabyn"
                  >
                    <a :href="'#/add_pinjia?orderno='+scope.row.orderno">立即评价</a>
                  </el-button>
                  <el-button
                    size="small"
                    v-if="scope.row.expressno"
                    type="primary"
                    class="mb10"
                    @click="logistics(scope.row.expressno)"
                  >查看物流</el-button>
                  <el-button
                    size="small"
                    v-if="scope.row.status==0"
                    type="primary"
                    class="mb10"
                    @click="goPay(scope.row.orderno,1)"
                  >立即支付</el-button>

                  <el-button
                    size="small"
                    v-if="scope.row.status==0"
                    type="primary"
                    @click="closeOrder(scope.row.orderno)"
                  >取消订单</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="mt20">
            <strong>订单信息：</strong>
          </div>
          <div class="mt10">
            商品总额：￥{{orderDetail.total}}
            <br />
            运费：￥{{orderDetail.shipfee}}
            <br />
            优惠：￥{{orderDetail.discount}}
            <br />
            订单备注：{{orderDetail.remark||"暂无备注"}}
            <br />
            交易时间：{{orderDetail.addtime}}
            <div v-if="orderDetail.refundremark2">拒绝备注:{{orderDetail.refundremark2}}</div>
            支付方式：{{orderDetail.paymethod==1?'微信':orderDetail.paymethod==2?'支付宝':'授信'}}
            <br />订单金额：
            <strong class="color-red">￥{{orderDetail.amount}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="user-main" v-if="orderType=='jforder'">
      <div class="layui-card user-cont">
        <div class="layui-card-header layui-card-header-auto">
          <h3>订单详情</h3>
        </div>
        <div class="layui-card-body">
          <div>
            <strong>收货人：</strong>
          </div>
          <div class="mt10">
            姓名：{{orderDetail.data[0].username}}
            <br />
            电话：{{orderDetail.data[0].telephone}}
            <br />
            地址：{{orderDetail.data[0].region}}{{orderDetail.data[0].address}}
          </div>
          <div class="mt20">
            <strong>订单产品：</strong>
          </div>
          <div class="cartcontent">
            <table class="layui-table" lay-skin="line">
              <thead>
                <tr class="theader" style="background-color: #f8f8f8;">
                  <th>商品</th>
                  <!-- <th class="cart-price">单价</th> -->
                  <th class="cart-numbers">数量</th>
                  <th class="cart-total">实付款</th>
                  <th class="cart-state">交易状态</th>
                  <th class="cart-ctrl">操作</th>
                </tr>
              </thead>
            </table>

            <table class="layui-table" lay-skin="row">
              <thead>
                <tr class="theader" style="background-color: #f8f8f8;">
                  <th colspan="6" style="color: #999;">
                    {{orderDetail.data[0].addtime}}
                    <span style="margin-left: 50px;">
                      订单号：
                      <span style="color: #000;">{{orderDetail.data[0].orderno}}</span>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a :href="'#/goodsdetail?id='+ orderDetail.data[0].id" target="_blank">
                      <div class="clearfix cpinfo flex">
                        <div class="img">
                          <img :src="orderDetail.data[0].indexpic" />
                        </div>
                        <div class="cont">
                          <div class="name">{{orderDetail.data[0].title}}</div>
                          <div class="info">{{orderDetail.data[0].specnames}}</div>
                        </div>
                        <div
                          class="cart-price"
                        >{{orderDetail.data[0].price}}*{{orderDetail.data[0].num}}</div>
                      </div>
                    </a>
                  </td>
                  <td class="cart-numbers">{{orderDetail.data[0].num}}</td>
                  <td class="cart-total">
                    <strong>{{orderDetail.data[0].amount}}积分</strong>
                  </td>
                  <td class="cart-state">
                    <span v-if="orderDetail.data[0].status==0">待付款</span>
                    <span v-if="orderDetail.data[0].status==1">待发货</span>
                    <span v-if="orderDetail.data[0].status==2">待收货</span>
                    <span v-if="orderDetail.data[0].status==3">已完成</span>
                    <span v-if="orderDetail.data[0].status==4">已取消</span>
                    <span v-if="orderDetail.data[0].status==5">已退款</span>
                    <br />
                    <!-- <a href="javascript:;" @click="orderdetail.data[0](orderDetail.data[0].orderno)">订单详情</a> -->
                  </td>
                  <td class="cart-ctrl">
                    <el-button
                      size="small"
                      v-if="orderDetail.data[0].status==2"
                      type="primary"
                      class="mb10"
                      @click="confirmGoods(orderDetail.data[0].orderno)"
                    >确认收货</el-button>
                    <el-button
                      size="small"
                      v-if="orderDetail.data[0].expressno"
                      type="primary"
                      class="mb10"
                      @click="logistics(orderDetail.data[0].expressno)"
                    >查看物流</el-button>
                    <el-button
                      size="small"
                      v-if="orderDetail.data[0].status==0"
                      type="primary"
                      class="mb10"
                      @click="goPay(orderDetail.data[0].orderno)"
                    >支付</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt20">
            <strong>订单信息：</strong>
          </div>
          <div class="mt10">
            商品积分：￥{{orderDetail.data[0].price}}
            <br />
            运费：￥{{orderDetail.data[0].shipfee}}
            <br />
            交易时间：{{orderDetail.data[0].addtime}}
            <br />订单支付积分：
            <strong class="color-red">{{orderDetail.data[0].amount}}积分</strong>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "Order",
  data() {
    return {
		audit:'',
		remark:'',
      userInfo: {},
      guid: sessionStorage.guid,
      indexData: {},
      keyword: "",

      orderDetail: { data: [{ username: "" }] },
      goodsKeyWord: "",
	  
	  levelid: JSON.parse(localStorage.jinruser).levelid,
	  showdialog:false,
	  product_list:{},
	  page:1,
	  cptype:0
    };
  },
  props: {
    orderno: {
      type: String
    },
	orderType:{
		type: String
	},
	isedit:{
		type: Boolean,
		default:false
	}
  },
  watch: {
    orderno(newValue, oldValue) {
		this.getOrderDetail();
		
    }
  },
  methods: {
	  baocun:function(){
		  this.$message({		    
		    message: "保存成功",
		    type: "success"
		  });
		  eventBus.$emit('cgback')
	  },
	  tianjia:function(){
		  console.log(this.cptype)
		  
		  this.getOrderList(this.cptype)
		this.showdialog=true
		
		this.cptype=this.cptype
	  },
	  add:async function(item){
		  console.log(item)
		  let ids=[]
		  if(item.speclist){
			  for(let i=0;i<item.speclist.length;i++){
				if(item.speclist[i].values){
					if(item.speclist[i].ids==''){
						this.$message({
						  showClose: true,
						  message: "请选择"+item.speclist[i].name,
						  type: "error"
						});
						return
					}else{
						ids.push(item.speclist[i].ids)
					}
				}
			  }
		  }
		  console.log(ids);
		  //return;
		  let res = await this.$fetch("member/orderdraft", {
		    body: {
		      orderno:this.orderno,
		  			act:'add',
		  			data:{
		  				productid:this.cptype==0?item.productid:item.id,
		  				specification:ids.join("_"),
		  				num:item.num
		  			}
		    }
		  });
		  this.$message({
		    showClose: true,
		    message: "操作成功",
		    type: "success"
		  });
		  this.getcgDetail();
		  
		  
	  },
	  searchgoods() {
	    this.getOrderList(this.cptype);
	  },
	  currentPage(e) {
	    this.page = e;
	    this.getOrderList(this.cptype);
		console.log(111)
	  },
	  //获取商品列表
	  tab:function(n){
		  this.page=1;
		  this.getOrderList(n)
	  },
	  async getOrderList(type) {
		  this.cptype=type
		  
		  let url="shop/productsign"
		  if(type==1){
			  url="Shop/productlist"
		  }
		
	    let product_list = await this.$fetch(url, {
	      body: {
	        page: this.page,
	        pagesize:5,
	        keyword: this.keyword
	      }
	    });
	    for (let i = 0; i < product_list.data.length; i++) {
	      product_list.data[i]["num"] = 1;
		  
		  
		 if(product_list.data[i].speclist){
			 product_list.data[i].speclist=JSON.parse(product_list.data[i].speclist)
			 if(product_list.data[i].speclist.length>0){
				 for (let a=0;a<product_list.data[i].speclist.length;a++){
				 	product_list.data[i].speclist[a].ids=''
				 }
			 }
			 console.log("ids",product_list.data[i].speclist)
		 }
	    }
		
	    this.product_list = product_list;
	    console.log("product_list", product_list);
	  },
	  
    // 封装获取数据的方法
    async getcgDetail() {
      let res = await this.$fetch("member/orderdraft", {
        body: {
			act:'detail',
			guid: this.guid,
			orderno: this.orderno
        }
      });
      console.log("订单信息", res);
      res.shipfee = parseFloat(res.shipfee);
      res.amount = parseFloat(res.amount);
      let text = "";
      if (res.auditstatus == 0) {
        text = "待审核";
      } else if (res.auditstatus == 1) {
        text = "已审核";
      } else if (res.auditstatus == 2) {
        text = "审核未通过";
      } 
      res["statusText"] = text;
     
      this.orderDetail = res;
    },
	async getOrderDetail() {
		console.log(this.orderType)
		let url=''
		switch(this.orderType){
			case "order":
				url="Member/orderdetail";
				break;
			case "jforder":
				url="member/ordergiftlist";
				break;
		}
	 // let url = this.jifen ? "member/ordergiftlist" : "Member/orderdetail";
	  let res = await this.$fetch(url, {
	    body: {
			
	      guid: this.guid,
	      orderno: this.orderno
	    }
	  });
	  console.log("订单信息", res);
	  res.shipfee = parseFloat(res.shipfee);
	  res.amount = parseFloat(res.amount);
	  let text = "";
	  if (res.status == 0) {
	    text = "待付款";
	  } else if (res.status == 1) {
	    text = "待发货";
	  } else if (res.status == 2) {
	    text = "待收货";
	  } else if (res.status == 3) {
	    text = "已完成";
	  } else if (res.status == 4) {
	    text = "已取消";
	  } else if (res.status == 5) {
	    text = "已退款";
	  }
	  if (res.isrefundtag == 1) {
	    text = "退款处理中";
	  }
	  res["statusText"] = text;
	  if (!this.jifen) {
	    for (let j = 0; j < res.detail.length; j++) {
	      if (res.detail[j].iscomment == 0) {
	        res["needComment"] = true;
	        break;
	      }
	    }
	  }
	  this.orderDetail = res;
	},
    // 去支付
    goPay(orderno, paymethod) {
      this.$router.push({
        path: `/jieguo?orderno=${orderno}&paymethod=${paymethod}`
      });
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return [1, 4];
      } else if (columnIndex === 4) {
        return [0, 0];
      } else if (columnIndex === 5) {
        return [0, 0];
      } else if (columnIndex === 6) {
        return [0, 0];
      }
    },
	arraySpanMethod2({ row, column, rowIndex, columnIndex }) {
	  if (columnIndex === 3) {
	    return [1, 3];
	  } else if (columnIndex === 4) {
	    return [0, 0];
	  } else if (columnIndex === 5) {
	    return [0, 0];
	  }
	},
    // 取消订单
    async closeOrder(orderno) {
      this.$confirm(`是否取消订单`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$fetch("member/cancelorder", {
            body: { orderno }
          });
          if (res) {
            this.$message({
              type: "success",
              message: "提交成功!"
            });
            this.getOrderDetail();
          }
        })
        .catch(() => {});
    },
    // 申请退款
    async returnMoney(orderno) {
      this.$confirm(`是否申请退款?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$fetch("member/refundordertotal", {
            body: { orderno }
          });
          if (res) {
            this.$message({
              type: "success",
              message: "提交成功!"
            });
            this.getOrderDetail();
          }
        })
        .catch(() => {});
    },

    // 确认收货
    async confirmGoods(orderno) {
      // let res = ajaxMethod("confirmGoods", { guid: this.guid, orderno });
      let res = await this.$fetch("member/confirmorder", {
        body: { guid: this.guid, orderno }
      });
      if (res) {
        layer.alert("操作成功", { icon: 1 });
        this.getOrderDetail();
      }
    },
    // 搜索
    search() {
      this.getOrderDetail();
    },
	async xiugaiNum2(item, type, num) {
	  if (type == "add") {
	    num = num + 1;
	  } else {
	    num = num - 1;
	  }
	  item.num=num
	},
	
	// 修改单个商品数量
	async xiugaiNum(item, type, num) {
	  if (type == "add") {
	    num = num + 1;
	  } else {
	    num = num - 1;
	  }
	  item.num=num
	 //console.log(item.num)
	  this.changeNum(item)
	},
	async changeNum(item){
	  console.log(item)
	  //return
	   let res = await this.$fetch("member/orderdraft", {
	    body: {
	      orderno:this.orderno,
			act:'edit',
			data:{
				productid:item.productid,
				specification:item.specification,
				num:item.num
			}
	    }
	  });
	  this.getcgDetail();
	},
	async detelecp(id) {
		
		this.$confirm("您确认要删除吗?", "提示", {
				type: "warning"
			})
			.then(async () => {				
				let res = await this.$fetch("member/orderdraft", {
					body: {
						orderno:this.orderno,
						act:'deletedetail',
						detailid:id
					}
				});
				if (res) {
					this.$message.success("删除成功");
					this.getcgDetail();
				}
			})
	},
	
	
	async reshenghe(orderno) {
		this.$confirm("您确认要重新提交审核吗?", "提示", {
				type: "warning"
			})
			.then(async () => {						
				let res = await this.$fetch("member/orderdraft", {
					body: {
						act:'submitaudit',
						orderno:orderno
					}
				});
				if (res) {
					this.$message.success("提交成功");
					this.getcgDetail();
					eventBus.$emit('changeshnum')
				}
			})
	},
	async submitcgOrder(orderno) {				
		this.$confirm("您确认要提交正式订单吗?", "提示", {
				type: "warning"
			})
			.then(async () => {						
				let res = await this.$fetch("member/orderdraft", {
					body: {
						act:'createorder',
						orderno:orderno
					}
				});
				if (res) {
					this.$message.success("提交成功");
					this.getcgDetail();
					eventBus.$emit('changeshnum')
					this.goPay(orderno,1)
					
				}
			})
	},
	async detelecgOrder(ids) {
		
		this.$confirm("您确认要删除吗?", "提示", {
				type: "warning"
			})
			.then(async () => {
				if (!ids) {
					ids = this.multipleSelection.map(item => {
						return item.id;
					});
	
					ids = ids.join(",");
				}
				//console.log("ids",ids); return;
				let res = await this.$fetch("member/orderdraft", {
					body: {
						act:'delete',
						ids:ids
					}
				});
				if (res) {
					this.$message.success("删除成功");
					eventBus.$emit('changeshnum')
					this.getcgDetail();
				}
			})
	},
	
	shcgorder:async function(){
		console.log(this.audit,this.remark)
		
		layer.closeAll(); 
		this.$confirm("您确认要提交审核结果吗?", "提示", {
				type: "warning"
			})
			.then(async () => {						
				let res = await this.$fetch("member/orderdraft", {
					body: {
						act:'audit',
						orderno:this.orderDetail.orderno,
						status:this.audit,
						remark:this.remark
					}
				});
				if (res) {
					this.$message.success("审核成功");
					this.getcgDetail();
					eventBus.$emit('changeshnum')
				}
			})
	},
	shenheOrder:function(){
		let that = this;
		
		layui.use(["form", "layer"], function() {
		  var form = layui.form;
		  var layer = layui.layer;
		  
		  that.addressModal = layer.open({
		    title: "审核草稿订单",
		    area: "800px",
		    type: 1,
		    content: $("#adrpop")
		  });
		  
		});
	},
	
	
	
	
	
	

    // 查看物流
    logistics(logistics) {
      console.log(logistics);
      layer.open({
        type: 2,
        title: "查看物流",
        shadeClose: true,
        shade: 0.8,
        area: ["400px", "90%"],
        content: `http://m.kuaidi100.com/index_all.html?type=&postid=${logistics}` //iframe的url
      });
    }
  },
  async mounted() {
	  
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    // this.orderno = getParameterByName("orderno");
   // this.getOrderDetail();
	if(this.orderType=='cgorder'){
		this.getcgDetail()
		this.cptype=0
	}else{
		this.getOrderDetail();
	}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.cont {
  // width: 150px;
  margin: 0 10px !important;
}
.cart-price {
  width: 60px;
}
.cartcontent td {
  padding: 0;
}
.goodsList {
    .goodsItem_quick { padding:10px 0;  border-bottom: 1px solid #eeeeee;
	.goodsimg { width: 80px; height:80px;}
      .goodsInfo {
        .goodsDetail {
          flex-direction: column;
          justify-content: space-around;
          height:60px;
          font-size: 14px;
          color: #3c3c3c;
          // line-height: 20px;
          align-items: flex-start;
          margin-left: 20px;
          p {
            margin: 0;
          }
         
        }
		
      }
	.price { width: 100px; text-align: center;
	   font-size: 16px;
	   font-family: Microsoft YaHei;
	   font-weight: bold;
	   color: rgba(243, 153, 10, 1);
	}
      
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderDetail.vue